<template>
  <div>
    <el-card>
      <div style="float: right">
        <yearcomponent @change="handler_year" />

        <el-select
          v-model="valuetrimestres"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in trimestres"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="valueCompanys"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in companys"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="DimensionProducto"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in DimensionProductoOptions"
            :key="item.Code"
            :label="item.Name"
            :value="item.Code"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="DimensionDepartamento"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in DimensionDepartamentoOptions"
            :key="item.Code"
            :label="item.Name"
            :value="item.Code"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="valueMoney"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div style="margin-top: 50px">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item
            :title="collapseName[valuetrimestres].mes1"
            name="1"
          >
            <rabbey-table3
              :columns="months"
              :data="dataReStatusMonth1"
              :loading="loading"
              :maxheight="800"
              :paginationApi="{
                currentPage: 1,
                pageSize: 200
              }"
              :pageSizes="[200, 400, 600]"
              default-expand-all
            ></rabbey-table3>
          </el-collapse-item>

          <el-collapse-item
            :title="collapseName[valuetrimestres].mes2"
            name="2"
          >
            <rabbey-table3
              :columns="months"
              :data="dataReStatusMonth2"
              :loading="loading"
              :maxheight="800"
              :paginationApi="{
                currentPage: 1,
                pageSize: 200
              }"
              :pageSizes="[200, 400, 600]"
              default-expand-all
            ></rabbey-table3>
          </el-collapse-item>

          <el-collapse-item
            :title="collapseName[valuetrimestres].mes3"
            name="3"
          >
            <rabbey-table3
              :columns="months"
              :data="dataReStatusMonth3"
              :loading="loading"
              :maxheight="800"
              :paginationApi="{
                currentPage: 1,
                pageSize: 200
              }"
              :pageSizes="[200, 400, 600]"
              default-expand-all
            ></rabbey-table3>
          </el-collapse-item>

          <el-collapse-item title="RESULTADO DEL TRIMESTRE" name="4">
            <rabbey-table3
              :columns="months"
              :data="dataReStatusTotal"
              :loading="loading"
              :maxheight="800"
              :paginationApi="{
                currentPage: 1,
                pageSize: 200
              }"
              :pageSizes="[200, 400, 600]"
              default-expand-all
            ></rabbey-table3>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-card>
  </div>
</template>

<script>
// import { Months } from "@/helpers/MonthsColumns";
import ColumnsBudge2 from "@/views/modules/Status/columns/ColumnsBudge2";
import yearcomponent from "@/components/Global_System/YearsComponent";

export default {
  name: "Budgets2",
  components: { yearcomponent },
  data() {
    return {
      months: ColumnsBudge2,
      loading: false,
      activeName: 1,
      collapseName: {
        1: { mes1: "ENERO", mes2: "FEBRERO", mes3: "MARZO" },
        4: { mes1: "ABRIL", mes2: "MAYO", mes3: "JUNIO" },
        7: { mes1: "JULIO", mes2: "AGOSTO", mes3: "SEPTIEMBRE" },
        10: { mes1: "OCTUBRE", mes2: "NOVIEMBRE", mes3: "DICIEMBRE" }
      },
      trimestres: [
        {
          value: 1,
          label: "Ene-Mar"
        },
        {
          value: 4,
          label: "Abr-Jun"
        },
        {
          value: 7,
          label: "Jul-Sep"
        },
        {
          value: 10,
          label: "Oct-Dic"
        }
      ],
      options: [
        {
          value: "RD",
          label: "RD$"
        },
        {
          value: "US",
          label: "US$"
        }
      ],
      companys: [
        {
          value: 4,
          label: "Magycorp Technologies"
        },
        {
          value: 5,
          label: "Magycorp SA"
        },
        {
          value: 2,
          label: "MAGYTRACK"
        },
        {
          value: 1,
          label: "TENNOS BUSINESS"
        },
        {
          value: 9,
          label: "VENTAFIEL TECHNOLOGIES"
        },
        {
          value: 6,
          label: "RABBEY"
        },
        {
          value: 7,
          label: "NUPSHOP"
        },
        {
          value: "Consolidado",
          label: "Consolidado"
        }
      ],
      dataReStatusMonth1: [],
      dataReStatusMonth2: [],
      dataReStatusMonth3: [],
      dataReStatusTotal: [],
      year: 2023,
      valuetrimestres: 1,
      valueCompanys: 4,
      valueMoney: "RD",
      DimensionProductoOptions: [],
      DimensionProducto: "*",
      DimensionDepartamentoOptions: [],
      DimensionDepartamento: "*"
    };
  },
  mounted() {
    this.getDimension();
    this.GetBudget2();
  },
  methods: {
    handler_year(_year) {
      this.year = _year;
      this.GetBudget2();
    },
    getDimension() {
      this.loading = true;

      this.$http
        .get(`/api/resultsStatus/GetDimesionProducto`)
        .then((resp) => {
          this.loading = false;
          this.DimensionProductoOptions = resp.data;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));

      this.$http
        .get("/api/resultsStatus/GetDimesionDepartamento")
        .then((resp) => {
          this.loading = false;
          this.DimensionDepartamentoOptions = resp.data;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    },
    GetBudget2() {
      this.loading = true;

      this.dataReStatusMonth1 = [];
      this.dataReStatusMonth2 = [];
      this.dataReStatusMonth3 = [];
      this.dataReStatusTotal = [];

      var params = {
        option: this.valueCompanys,
        year: this.year,
        month: this.valuetrimestres,
        divisa: this.valueMoney,
        dim_pro: this.DimensionProducto,
        dim_dep: this.DimensionDepartamento
      };

      this.$http
        .get(`/api/resultsStatus/GetBudget2`, {
          params: params
        })
        .then((resp) => {
          this.loading = false;
          // console.logvalueMoney;

          resp.data.forEach((data) => {
            // console.log("aaa", data);
            this.dataReStatusMonth1.push({
              cuenta: data.cuenta,
              nombre: data.nombre,
              pres0: data.mes1,
              ejec1: data.ejec1,
              var1: data.mes1 > 0 ? data.ejec1 - data.mes1 : "",
              tot: data.mes1 > 0 ? data.ejec1 / data.mes1 - 1 : "",
              negrita: data.negrita
            });

            this.dataReStatusMonth2.push({
              cuenta: data.cuenta,
              nombre: data.nombre,
              pres0: data.mes2,
              ejec1: data.ejec2,
              var1: data.mes2 > 0 ? data.ejec2 - data.mes2 : "",
              tot: data.mes2 > 0 ? data.ejec2 / data.mes2 - 1 : "",
              negrita: data.negrita
            });

            this.dataReStatusMonth3.push({
              cuenta: data.cuenta,
              nombre: data.nombre,
              pres0: data.mes3,
              ejec1: data.ejec3,
              var1: data.mes3 > 0 ? data.ejec3 - data.mes3 : "",
              tot: data.mes3 > 0 ? data.ejec3 / data.mes3 - 1 : "",
              negrita: data.negrita
            });

            this.dataReStatusTotal.push({
              cuenta: data.cuenta,
              nombre: data.nombre,
              pres0: data.mes1 + data.mes2 + data.mes3,
              ejec1: data.tot - (data.mes1 + data.mes2 + data.mes3),
              var1:
                data.ejec1 +
                data.ejec2 +
                data.ejec3 -
                (data.mes1 + data.mes2 + data.mes3),
              tot:
                data.mes1 + data.mes2 + data.mes3 > 0
                  ? (data.ejec1 + data.ejec2 + data.ejec3) /
                      (data.mes1 + data.mes2 + data.mes3) -
                    1
                  : "",
              negrita: data.negrita
            });
          });

          // this.dataReStatus = resp.data;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    }
  },
  watch: {
    DimensionProducto() {
      this.GetBudget2();
    },
    DimensionDepartamento() {
      this.GetBudget2();
    },
    valueCompanys() {
      this.GetBudget2();
    },
    year() {
      this.GetBudget2();
    },
    valueMoney() {
      this.GetBudget2();
    },
    valuetrimestres() {
      this.GetBudget2();
    }
  }
};
</script>

<style scoped></style>
